<template>
  <div class="page-content add-payment">

    <!-- BREADCRUMB -->
    <f-p-breadcrumb
      :breadcrumbOuter="$lang.messages.payments.toUpperCase()"
      :breadcrumbTo="'Unpaid'"
      :breadcrumbToTitle="$lang.messages.unpaid"
      :breadcrumbInner="$lang.messages.bb_childSupport.toUpperCase()"
      :breadcrumbIsHistory="false">
    </f-p-breadcrumb>

    <div class="page-wrapper">
      <fp-add-payment
        :type="type"
        :guid="guid"
        :bluredProp="bluredProp"
        @clearInputErrorsPayments="clearInputErrorsPayments"
        @clearOthersPayments="clearOthersPayments"
        @checkAnyInput="checkAnyInput"
      >
      </fp-add-payment>
    </div>

  </div>
</template>

<script>
import FpAddPayment from '@/components/common/FPAddPayment';
import FPBreadcrumb from "@/components/common/FPBreadcrumb";

export default {
  name: "childMaintenanceAddPayment",
  components: {
    FpAddPayment,
    'f-p-breadcrumb': FPBreadcrumb
  },
  props: {
    bluredProp: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      type: this.$CHILD_EXPENSE_TYPE,
      guid: this.$route.params.id,
     };
  },
  methods: {
    clearInputErrorsPayments (e) {
      this.$emit('clearInputErrorsPayments', e)
    },
    clearOthersPayments (e) {
      this.$emit('clearOthersPayments', e)
    },
    checkAnyInput () {
      this.$emit('checkAnyInput')
    }
  }
};
</script>
